define('item_relations_cell.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('item_relations_cell', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<li class=\"item-relations-cell\"><div data-type=\"backbone.collection.view.cell\"></div></li>  ";
},"useData":true}, 'extensions/RSM/Applied_Systems_Theme/1.4.0/', 'extensions/RSM/Applied_Systems_Theme/1.4.0/', Handlebars);
});